<template>
  <div class="hbh" id="hbh">
    <div class="table-responsive">
      <b-row class="title">
        <b-col cols="9">
          <div class="title main TournamentTitle" >
            <p>{{data.full_name}} <span v-if="data.pft_time !== ''">- Projected Finish Time - {{ data.pft_time }}</span></p>
            <p class="lastUpdate">
              <span>
                Last Score Update {{ data.last_scores_update_date }}
                {{ data.last_scores_update_time }} - (Local Time)
              </span>
            </p>
          </div>
        </b-col>
        <b-col>
          <div class="sponLogo">
            <!-- <i v-b-toggle.collapse-1 class="fa-solid fa-circle-info"></i> -->
            <template v-if="config.VUE_APP_ID == 'bvt'">
              <img class="informationImg" v-b-toggle="'collapse-1'" src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/bvt/2024/07/Information.png">
            </template>
            <template v-else>
              <i
                v-b-toggle="'collapse-1'"
                class="fa-solid fa-circle-info"
              ></i>
            </template>
          </div>
        </b-col>
      </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
      <table class="tableMob">
        <thead>
          <tr class="title">
            <template v-if="data.multi_course == 'Y' && data.tt_code == '37'">
              <th class="thWidth" colspan="5"></th>
            </template>
            <template v-else>
              <template v-if="data.pft_round !='1'">
                <th class="thWidth" colspan="5"></th>
              </template>
              <template v-else>
                <th class="thWidth" colspan="4"></th>
              </template>
            </template>
            
            <th class="firstNine">
              1
            </th>
            <th class="firstNine">
              2
            </th>
            <th class="firstNine">
              3
            </th>
            <th class="firstNine">
              4
            </th>
            <th class="firstNine">
              5
            </th>
            <th class="firstNine">
              6
            </th>
            <th class="firstNine">
              7
            </th>
            <th class="firstNine">
              8
            </th>
            <th class="firstNine">
              9
            </th>
            <th>
              Out
            </th>
            <th>
              10
            </th>
            <th>
              11
            </th>
            <th>
              12
            </th>
            <th>
              13
            </th>
            <th>
              14
            </th>
            <th>
              15
            </th>
            <th>
              16
            </th>
            <th>
              17
            </th>
            <th>
              18
            </th>
            <th>
              IN
            </th>
            <th>
              TOT
            </th>
          </tr>
          <template v-if="data.multi_course === 'Y'">
            <tr
              :class="multi.course_X_colour + 'row'"
              v-for="(multi, index) in data.courses.courses_entry"
              :key="index"
            >
              <th class="CP">
                {{ multi.course_X_id }}
              </th>
              <th class="CN" style="text-align:left; padding-left:12px;">
                <span v-if="index === 1">
                  Player Name
                </span>
              </th>
              <th class="CF" :class="{teamNat : title.includes('Team') && data.team_sb == 'Y'}">
                <span v-if="index === 1">
                  <span>Nat</span>
                </span>
              </th>
              <th
                class="CP"
                v-if="data.score_type === 'P' || data.stableford === 'N'"
              >
                <span v-if="index === 1 && title.includes('Team') && data.team_sb == 'Y'">
                  Total Pts
                </span>
                <span v-else-if="index === 1">
                  Tot
                </span>
              </th>
              <template v-if="data.team_sb == 'Y'">
                <template v-if="title.includes('Team')">
                  <th
                    class="CP"
                  >
                    <span v-if="index === 1">
                      R{{data.pft_round}} 
                    </span>
                  </th>
                </template>
                <template v-else>
                  <th
                    class="CP"
                    v-if="data.score_type === 'P' || data.stableford === 'N' && data.pft_round !='1'"
                  >
                    <span v-if="index === 1">
                      R{{data.pft_round}} 
                    </span>
                  </th>
                </template>
              </template>
              <!-- <template v-else>
                <th
                  class="CP"
                  v-if="data.score_type === 'P' || data.stableford === 'N' && data.pft_round !='1'"
                >
                  <span v-if="index === 1">
                    R{{data.pft_round}} .
                  </span>
                </th>
              </template> -->
              <template
                v-if="
                  data.score_type === 'P' ||
                    (data.tt_type === 'P' && data.stableford === 'Y')
                "
              >
                <th class="CF">
                  <span v-if="index === 1">
                    Points
                  </span>
                </th>
              </template>
              <template
                v-if="data.stableford_revised == 'N' && data.pft_round !='1'"
              >
                <th class="CF">
                  <span v-if="index === 1">
                     R{{data.pft_round}}
                  </span>
                </th>
              </template>
              <th
                class="CP"
                v-for="(course, index) in multi.course_X_par
                  .split(',')
                  .slice(0, 9)"
                :key="index + Math.random()"
              >
                {{ course }}
              </th>
              <th class="CP">
                {{ multi.course_X_out_par.slice(1) }}
              </th>
              <th
                class="CP"
                v-for="(course, index) in multi.course_X_par
                  .split(',')
                  .slice(9, 18)"
                :key="index + Math.random()"
              >
                {{ course }}
              </th>
              <th class="CP">
                {{ multi.course_X_in_par.slice(1) }}
              </th>
              <th class="CP">
                {{ multi.course_X_total_par }}
              </th>
            </tr>
          </template>
          <tr v-else class="title">
            <th class="CP">
              Pos
            </th>
            <th class="CN" style="text-align:left; padding-left:12px;">
              Player Name
            </th>
            <th class="CF">
              <span>Nat</span>
            </th>
            <template v-if="data.score_type === 'P' || data.stableford === 'N'">
              <th class="CT" v-if="data.pft_round !='1'">
                Tot
              </th>
              <th class="CF" v-if="data.pft_round == '1'">
                Par
              </th>
              <template v-if="data.bball_team === 'Y'"> </template>
              <template v-else>
                <th v-if="data.pft_round !='1'">
                  R{{data.pft_round}}
                </th>
              </template>
            </template>
            <template
              v-if="
                data.score_type === 'P' ||
                  (data.tt_type === 'P' && data.stableford === 'Y')
              "
            >
            <template v-if="data.show_points_gross == 'P' || data.show_points_gross == 'B'">
              <th>
                Points
              </th>
            </template>
            <template v-else-if="data.show_points_gross == 'G'">
              <th>
                Score
              </th>
            </template>
            </template>
            <th
              v-for="(course, index) in course_par(0, 9)"
              :key="index + Math.random()"
            >
              {{ course }}
            </th>
            <th v-if="data.course_out_par">
              {{ data.course_out_par.slice(1) }}
            </th>
            <th
              v-for="(course, index) in course_par(9, 18)"
              :key="index + Math.random()"
            >
              {{ course }}
            </th>
            <th v-if="data.course_in_par">
              {{ data.course_in_par.slice(1) }}
            </th>
            <th>
              {{ data.course_total_par }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.stableford == 'Y' &&
                data.bball_pro_am_single == 'Y' &&
                data.tt_enter_gross == 'Y' &&
                data.tt_calc_points == 'Y'
            "
          >
            <tr
              class="RT hbhRow"
              v-for="(playerData, index) in data.team_scores.team_scores_entry"
              :key="index + Math.random()"
            >
              <td v-if="playerData.pos !== 'CUT'">
                <span
                  v-if="
                    index !== 0 &&
                      (playerData.tied !== '=' ||
                        data.scores.scores_entry[index - 1].pos !==
                          playerData.pos)
                  "
                  class="CP pos"
                >
                  {{ playerData.pos }}
                </span>
                <span v-else-if="index === 0" class="CP pos">
                  {{ playerData.pos }}
                </span>
                <span v-else></span>
              </td>

              <td
                style="text-align:left"
                v-if="playerData.pos !== 'CUT'"
                :title="playerData.member_no"
                :class="{
                  'text-up': playerData.posChang == 'up',
                  'text-down': playerData.posChang == 'down'
                }"
              >
                <template v-if="playerData.profile == 'Y'">
                  <a
                    class="playerName"
                    :href="'/playerprofile/' + playerData.id"
                    target="_blank"
                  >
                    {{ playerData.name }}</a
                  >
                </template>
                <template v-else>
                  {{ playerData.name }}
                </template>
                <span v-if="playerData.pro_ind === 'Am'">(a)</span>
                <span v-if="data.multi_course === 'Y'">
                  <span
                    class="HBHDot"
                    :class="playerData['course_colour_R' + data.pft_round]"
                  >
                    •
                  </span>
                </span>
                <span
                  v-if="showGender === 'Y'"
                  class="multiDot-size-reportgender"
                  :class="{
                    female: playerData.gender === 'F',
                    male: playerData.gender === 'M'
                  }"
                  >•</span
                >
              </td>
              <td
                v-if="playerData.pos !== 'CUT'"
                class="CF"
                :title="playerData.nationality"
              >
                  <template v-if="data.represents_flag_type === 'N'">
                    {{ playerData.nationality }}
                  </template>
                  <template v-else>
                    <img
                      class="flag"
                      :src="
                        (config.VUE_APP_FLAG_URL + playerData.nationality)
                          | lowercase
                      "
                    />
                  </template>
              </td>
              <template
                v-if="data.score_type === 'P' || data.stableford === 'N'"
              >
                <template
                  v-if="
                    playerData['score_R' + roundsPlayer] == 'WDN' ||
                      playerData['score_R' + roundsPlayer] == 'RTD' ||
                      playerData['score_R' + roundsPlayer] == 'DSQ'
                  "
                >
                  <td>{{ playerData.score }}</td>
                </template>
                <template v-else>
                  <td v-if="playerData.pos !== 'CUT'" class="CT">
                    <span v-if="playerData.vspar < 0" :class="up">
                      {{ playerData.vspar }}
                    </span>
                    <span v-else-if="playerData.vspar > 0" :class="down">
                      {{ playerData.vspar }}
                    </span>
                    <span v-else>
                      {{ playerData.vspar }}
                    </span>
                  </td>
                </template>
                <template
                  v-if="
                    playerData['score_R' + roundsPlayer] == 'WDN' ||
                      playerData['score_R' + roundsPlayer] == 'RTD' ||
                      playerData['score_R' + roundsPlayer] == 'DSQ'
                  "
                >
                  <td></td>
                </template>
                <template v-else>
                  <template v-if="data.bball_team === 'Y'"> </template>
                  <template v-else>
                    <td v-if="playerData.pos !== 'CUT'">
                      <span
                        v-if="playerData['vspar_R' + data.pft_round] < 0"
                        :class="up"
                      >
                        {{ playerData["vspar_R" + data.pft_round] }}
                      </span>
                      <span
                        v-else-if="playerData['vspar_R' + data.pft_round] > 0"
                        :class="down"
                      >
                        {{ playerData["vspar_R" + data.pft_round] }}
                      </span>
                      <span v-else>
                        {{ playerData["vspar_R" + data.pft_round] }}
                      </span>
                    </td>
                  </template>
                </template>
              </template>
              <template
                v-if="
                  data.score_type === 'P' ||
                    (data.tt_type === 'P' && data.stableford === 'Y')
                "
              >
                <td>{{ playerData.score }}</td>
              </template>

              <td class="cut" colspan="30" v-if="playerData.pos == 'CUT'">
                {{ playerData.pos }} {{ playerData.cut_pft_round }}
              </td>

              <template>
                <td
                  class="CS"
                  v-for="(r1, index) in (
                    playerData['hole_points_R' + data.pft_round] || ''
                  )
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span>
                    {{ r1 }}
                  </span>
                </td>
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <span>
                    <template
                      v-if="
                        playerData['score_R' + roundsPlayer] == 'WDN' ||
                          playerData['score_R' + roundsPlayer] == 'RTD' ||
                          playerData['score_R' + roundsPlayer] == 'DSQ'
                      "
                    >
                    </template>
                    <template v-else>
                      {{
                        sum(
                          (playerData["hole_points_R" + data.pft_round] || "")
                            .split(",")
                            .slice(0, 9)
                        )
                      }}
                    </template>
                  </span>
                </td>
                <td
                  class="CS"
                  v-for="(r1, index) in (
                    playerData['hole_points_R' + data.pft_round] || ''
                  )
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span>
                    {{ r1 }}
                  </span>
                </td>
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <span>
                    {{
                      sum(
                        (playerData["hole_points_R" + data.pft_round] || "")
                          .split(",")
                          .slice(9, 18)
                      )
                    }}
                  </span>
                </td>
                <td
                  v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                  class="CS"
                >
                  <span>
                    {{ playerData["score_R" + data.pft_round] }}
                  </span>
                </td>
                <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                  <span>
                    {{ playerData.score }}
                  </span>
                </td>
              </template>
            </tr>
          </template>
          <template v-else>
            <tr
              class="RT hbhRow"
              v-for="(playerData, index) in data.scores.scores_entry"
              :key="index + Math.random()"
            >
              <td v-if="playerData.pos !== 'CUT'">
                <span
                  v-if="
                    index !== 0 &&
                      (playerData.tied !== '=' ||
                        data.scores.scores_entry[index - 1].pos !==
                          playerData.pos)
                  "
                  class="CP pos"
                >
                  {{ playerData.pos }}
                </span>
                <span v-else-if="index === 0" class="CP pos">
                  {{ playerData.pos }}
                </span>
                <span v-else></span>
              </td>

              <td
                style="text-align:left"
                v-if="playerData.pos !== 'CUT'"
                :title="playerData.member_no"
                :class="{
                  'text-up': playerData.posChang == 'up',
                  'text-down': playerData.posChang == 'down'
                }"
              >
                <template v-if="playerData.profile == 'Y'">
                  <a
                    class="playerName"
                    :href="'/playerprofile/' + playerData.id"
                    target="_blank"
                  >
                    {{ playerData.name }}</a
                  >
                </template>
                <template v-else>
                  {{ playerData.name }}
                </template>
                <span v-if="playerData.pro_ind === 'Am'">(a)</span>
                <span v-if="data.multi_course === 'Y'">
                  <span
                    class="HBHDot"
                    :class="playerData['course_colour_R' + data.pft_round]"
                  >
                    •
                  </span>
                </span>
                <span
                  v-if="showGender === 'Y'"
                  class="multiDot-size-reportgender"
                  :class="{
                    female: playerData.gender === 'F',
                    male: playerData.gender === 'M'
                  }"
                  >•</span
                >
              </td>
              <td
                v-if="playerData.pos !== 'CUT'"
                class="CF"
                :title="playerData.nationality"
                :class="{teamNat : title.includes('Team') && data.team_sb == 'Y'}"
              >
                  <!-- <template v-if="data.represents_flag_type === 'N'">
                    {{ playerData.nationality }}
                  </template> -->
                  <template>
                  <span v-if="playerData.nationality === ''"></span>
                  <span v-else>
                    <template v-if="data.represents_flag_type === 'N'">
                      {{ playerData.nationality }}
                    </template>
                    <template v-else>
                      <img
                        class="flag"
                        :src="
                          (config.VUE_APP_FLAG_URL + playerData.nationality)
                            | lowercase
                        "
                      />
                    </template>
                  </span>
                  </template>
              </td>
              <template v-if="data.show_points_gross == 'P' || data.show_points_gross == 'B'">
                <template v-if="data.scores_type == 'P'">
                  <td>{{ playerData.score }}</td>
                </template>
                <template v-else>
                    <td v-if="playerData.pos !== 'CUT'" class="CT">
                      <span v-if="playerData.vspar < 0" :class="up">
                        {{ playerData.vspar }}
                      </span>
                      <span v-else-if="playerData.vspar > 0" :class="down">
                        {{ playerData.vspar }}
                      </span>
                      <span v-else>
                        {{ playerData.vspar }}
                      </span>
                    </td>
                </template>
              </template>
              <template v-else>
                <template v-if="data.scores_type == 'P'">
                  <td>{{ playerData.score }}</td>
                </template>
                <template v-else>
                    <td v-if="playerData.pos !== 'CUT'" class="CT">
                      <span v-if="playerData.vspar < 0" :class="up">
                        {{ playerData.vspar }}
                      </span>
                      <span v-else-if="playerData.vspar > 0" :class="down">
                        {{ playerData.vspar }}
                      </span>
                      <span v-else>
                        {{ playerData.vspar }}
                      </span>
                    </td>
                </template>
              </template>
              <template
                v-if="data.score_type === 'P' || data.stableford === 'N' && data.pft_round !='1'"
              >
                <template
                  v-if="
                    playerData['score_R' + roundsPlayer] == 'WDN' ||
                      playerData['score_R' + roundsPlayer] == 'RTD' ||
                      playerData['score_R' + roundsPlayer] == 'DSQ'
                  "
                >
                  <td v-if="data.pft_round == '1'">{{ playerData.score }}</td>
                </template>
                <template v-else>
                  <template v-if="title.includes('Team') && data.team_sb == 'Y'">
                    <td v-if="playerData.pos !== 'CUT'" class="CT">
                        <span
                          v-if="playerData.score > data.course_total_par"
                          class="down"
                        >
                          {{ playerData.score }}
                        </span>
                        <span
                          v-else-if="playerData.score < data.course_total_par"
                          class="up"
                        >
                          {{ playerData.score }}
                        </span>
                        <span v-else>
                          {{ playerData.score }}
                        </span>
                    </td>
                  </template>
                  <template v-else>
                    <template v-if="data.pft_round == '1'">
                      <td v-if="playerData.pos !== 'CUT'" class="CT">
                        <span v-if="playerData.vspar < 0" :class="up">
                          {{ playerData.vspar }}
                        </span>
                        <span v-else-if="playerData.vspar > 0" :class="down">
                          {{ playerData.vspar }}
                        </span>
                        <span v-else>
                          {{ playerData.vspar }}
                        </span>
                      </td>
                    </template>
                  </template>
                </template>
                <template
                  v-if="
                    playerData['score_R' + roundsPlayer] == 'WDN' ||
                      playerData['score_R' + roundsPlayer] == 'RTD' ||
                      playerData['score_R' + roundsPlayer] == 'DSQ'
                  "
                >
                  <td></td>
                </template>
                <template v-else>
                  <template v-if="data.team_sb == 'Y'">
                    <template v-if="title.includes('Team')">
                      <template v-if="title.includes('Scores Only')">
                        <td class="CT">
                          <span
                            v-if="playerData.score > data.course_total_par"
                            class="down"
                          >
                            {{ playerData.score }}
                          </span>
                          <span
                            v-else-if="playerData.score < data.course_total_par"
                            class="up"
                          >
                            {{ playerData.score }}
                          </span>
                          <span v-else>
                            {{ playerData.score }}
                          </span>
                        </td>
                      </template>
                      <template v-else>
                        <td v-if="playerData.pos !== 'CUT'" class="CT">
                          <span
                            v-if="playerData['score_R' + data.pft_round] > data.course_total_par"
                            class="down"
                          >
                            {{ playerData['score_R' + data.pft_round] }}
                          </span>
                          <span
                            v-else-if="playerData['score_R' + data.pft_round] < data.course_total_par"
                            class="up"
                          >
                            {{ playerData['score_R' + data.pft_round] }}
                          </span>
                          <span v-else>
                            {{ playerData['score_R' + data.pft_round] }}
                          </span>
                        </td>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="data.bball_team === 'Y'"> </template>
                      <template v-else>
                        <td v-if="playerData.pos !== 'CUT'">
                          <span
                            v-if="playerData['vspar_R' + data.pft_round] < 0"
                            :class="up"
                          >
                            {{ playerData["vspar_R" + data.pft_round] }}
                          </span>
                          <span
                            v-else-if="playerData['vspar_R' + data.pft_round] > 0"
                            :class="down"
                          >
                            {{ playerData["vspar_R" + data.pft_round] }}
                          </span>
                          <span v-else>
                            {{ playerData["vspar_R" + data.pft_round] }}
                          </span>
                        </td>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="data.bball_team === 'Y'"> </template>
                    <template v-else>
                      <td v-if="playerData.pos !== 'CUT' && data.pft_round != '1'">
                        <span
                          v-if="playerData['vspar_R' + data.pft_round] < 0"
                          :class="up"
                        >
                          {{ playerData["vspar_R" + data.pft_round] }}
                        </span>
                        <span
                          v-else-if="playerData['vspar_R' + data.pft_round] > 0"
                          :class="down"
                        >
                          {{ playerData["vspar_R" + data.pft_round] }}
                        </span>
                        <span v-else>
                          {{ playerData["vspar_R" + data.pft_round] }}
                        </span>
                      </td>
                    </template>
                  </template>
                </template>
              </template>
              <template
                v-if="
                  data.score_type === 'P' ||
                    (data.tt_type === 'P' && data.stableford === 'Y') 
                "
              >
                <template v-if="data.pft_round != '1' && data.show_points_gross == 'P' || data.tt_enter_points == 'Y'">
                  <td>{{ playerData.score }}</td>
                </template>
                <template v-else-if="data.show_points_gross == 'G'">
                  <td>
                      {{
                        sum(
                          (playerData["hole_scores_R" + data.pft_round] || "")
                            .split(",")
                            .slice(0, 18)
                        )
                      }}
                  </td>
                </template>
              </template>

              <td class="cut" colspan="30" v-if="playerData.pos == 'CUT'">
                {{ playerData.pos }} {{ playerData.cut_pft_round }}
              </td>

              <template
                v-if="
                  data.scores_type === 'G' &&
                    data.stableford === 'N' &&
                    data.bball_team === 'N'
                "
              >
                <template v-if="data.stableford === 'N'">
                  <template v-if="playerData.pos !== 'CUT'">
                    <td
                      class="CS"
                      v-for="(r1, index) in (
                        playerData['hole_scores_R' + data.pft_round] || ''
                      )
                        .split(',')
                        .slice(0, 9)"
                      :key="index + Math.random()"
                      :class="{'twoUnder': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -2, 
                      'oneUnder': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -1,
                      'twoOver': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',')[index] > 1,
                      'oneOver': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',')[index] == 1,
                      'moreOver': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',')[index] < -2,
                      } 
                    "
                    >
                      <span
                        class="twoUnder"
                        v-if="
                          (
                            playerData['hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == -2
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span
                        class="oneUnder"
                        v-else-if="
                          (
                            playerData['hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == -1
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span
                        class="oneOver"
                        v-else-if="
                          (
                            playerData['hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == 1
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span
                        class="twoOver"
                        v-else-if="
                          (
                            playerData['hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == 2
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span v-else>
                        {{ r1 }}
                      </span>
                    </td>
                  </template>
                  <!-- out -->
                  <td class="CS" v-if="playerData.pos !== 'CUT'">
                    <template v-if="(playerData['hole_scores_R' + roundsPlayer]).split(',').slice(8,9) != ''">
                      <span
                        v-if="
                          sum(
                            (playerData['hole_scores_R' + data.pft_round] || '')
                              .split(',')
                              .slice(0, 9)
                          ) > data.course_out_par
                        "
                        class="down"
                      >
                        <span

                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (
                                  playerData["hole_scores_R" + data.pft_round] ||
                                  ""
                                )
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                      </span>
                      <span
                        v-else-if="
                          sum(
                            (playerData['hole_scores_R' + data.pft_round] || '')
                              .split(',')
                              .slice(0, 9)
                          ) < data.course_out_par
                        "
                        class="up"
                      >
                        <span
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (
                                  playerData["hole_scores_R" + data.pft_round] ||
                                  ""
                                )
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                      </span>
                      <span v-else>
                        <span
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (
                                  playerData["hole_scores_R" + data.pft_round] ||
                                  ""
                                )
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                      </span>
                    </template>
                  </td>
                  <!-- end of out -->
                  <td
                    class="CS"
                    v-for="(r1, index) in (
                      playerData['hole_scores_R' + data.pft_round] || ''
                    )
                      .split(',')
                      .slice(9, 18)"
                    :key="index + Math.random()"
                    :class="{'twoUnder': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -2, 
                    'oneUnder': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -1,
                    'twoOver': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] > 1,
                    'oneOver': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == 1,
                    'moreOver': (playerData['hole_vspars_R' + roundsPlayer] || '').split(',').slice(9,18)[index] < -2,
                    } 
                    "
                  >
                    <span
                      class="twoUnder"
                      v-if="
                        (playerData['hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == -2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="
                        (playerData['hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == -1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="
                        (playerData['hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == 1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="
                        (playerData['hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == 2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <!-- In -->
                  <td class="CS" v-if="playerData.pos !== 'CUT'">
                      <template v-if="playerData.holes === '18' || playerData.holes === F">
                      <template v-if="(playerData['hole_scores_R' + roundsPlayer]).split(',').slice(17,18) != ''">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_scores_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) > data.course_in_par
                          "
                          class="down"
                        >
                          <span
                          >
                            <template
                              v-if="
                                playerData['score_R' + roundsPlayer] == 'WDN' ||
                                  playerData['score_R' + roundsPlayer] == 'RTD' ||
                                  playerData['score_R' + roundsPlayer] == 'DSQ'
                              "
                            >
                            </template>
                            <template v-else>
                              {{
                                sum(
                                  (
                                    playerData["hole_scores_R" + data.pft_round] ||
                                    ""
                                  )
                                    .split(",")
                                    .slice(9, 18)
                                )
                              }}
                            </template>
                          </span>
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_scores_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) < data.course_in_par
                          "
                          class="up"
                        >
                          <span
                          >
                            <template
                              v-if="
                                playerData['score_R' + roundsPlayer] == 'WDN' ||
                                  playerData['score_R' + roundsPlayer] == 'RTD' ||
                                  playerData['score_R' + roundsPlayer] == 'DSQ'
                              "
                            >
                            </template>
                            <template v-else>
                              {{
                                sum(
                                  (
                                    playerData["hole_scores_R" + data.pft_round] ||
                                    ""
                                  )
                                    .split(",")
                                    .slice(9, 18)
                                )
                              }}
                            </template>
                          </span>
                        </span>
                        <span v-else>
                          <span
                          >
                            <template
                              v-if="
                                playerData['score_R' + roundsPlayer] == 'WDN' ||
                                  playerData['score_R' + roundsPlayer] == 'RTD' ||
                                  playerData['score_R' + roundsPlayer] == 'DSQ'
                              "
                            >
                            </template>
                            <template v-else>
                              {{
                                sum(
                                  (
                                    playerData["hole_scores_R" + data.pft_round] ||
                                    ""
                                  )
                                    .split(",")
                                    .slice(9, 18)
                                )
                              }}
                            </template>
                          </span>
                        </span>
                      </template>
                    </template>
                  </td>
                  <!-- end of in -->
                  <!-- total -->
                  <td
                    v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                    class="CS"
                  >
                    <template v-if="playerData.holes === '18' || playerData.holes === F">
                      <span
                        v-if="
                          playerData['hole_scores_R' + data.pft_round] >
                            data.course_total_par
                        "
                        class="down"
                      >
                        {{ playerData["score_R" + data.pft_round] }}
                      </span>
                      <span
                        v-else-if="
                          playerData['hole_scores_R' + data.pft_round] <
                            data.course_total_par
                        "
                        class="up"
                      >
                        {{ playerData["score_R" + data.pft_round] }}
                      </span>
                      <span v-else>
                        {{ playerData["score_R" + data.pft_round] }}
                      </span>
                    </template>
                  </td>
                  <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                    <template v-if="playerData.holes === '18' || playerData.holes === F">
                      <template v-if="playerData.score_found == 'Y'">
                        <span
                          v-if="playerData.score > data.course_total_par"
                          class="down"
                        >
                          {{ playerData.score }}
                        </span>
                        <span
                          v-else-if="playerData.score < data.course_total_par"
                          class="up"
                        >
                          {{ playerData.score }}
                        </span>
                        <span v-else>
                          {{ playerData.score }}
                        </span>
                      </template>
                      <template v-else>
                        <span
                          v-if="
                            sum(
                              (playerData['hole_scores_R' + roundsPlayer] || '')
                                .split(',')
                                .slice(0, 18)
                            ) > data.course_total_par
                          "
                          class="down"
                        >
                          <span v-if="playerData.holes === '18' || playerData.holes === F">
                            {{
                              sum(
                                (playerData["hole_scores_R" + roundsPlayer] || "")
                                  .split(",")
                                  .slice(0, 18)
                              )
                            }}
                          </span>
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_scores_R' + roundsPlayer] || '')
                                .split(',')
                                .slice(0, 18)
                            ) < data.course_total_par
                          "
                          class="up"
                        >
                          <span v-if="playerData.holes === '18' || playerData.holes === F">
                            {{
                              sum(
                                (playerData["hole_scores_R" + roundsPlayer] || "")
                                  .split(",")
                                  .slice(0, 18)
                              )
                            }}
                          </span>
                        </span>
                        <span v-else>
                          <span v-if="playerData.holes === '18' || playerData.holes === F">
                            {{
                              sum(
                                (playerData["hole_scores_R" + roundsPlayer] || "")
                                  .split(",")
                                  .slice(0, 18)
                              )
                            }}
                          </span>
                        </span>
                      </template>

                    </template>
                  </td>
                  <!-- end of total -->
                </template>
              </template>
              <!-- Old way -->
              <!-- (data.scores_type === 'N' && data.bball_team === 'Y') || data.strokeplay_team_event == 'Y' && data.team_net == 'N'" -->
              <template
                v-else-if="
                  (data.scores_type === 'N' && data.bball_team === 'Y') || data.strokeplay_team_event == 'Y' && data.team_net == 'N'" 
              >
                <template v-if="playerData.pos !== 'CUT'">
                  <td
                    class="CS"
                    v-for="(r1, index) in (
                      playerData['team_hole_vspars_R' + data.pft_round] || ''
                    )
                      .split(',')
                      .slice(0, 9)"
                    :key="index + Math.random()"
                    :class="{'twoUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -2, 
                    'oneUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -1,
                    'twoOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] > 1,
                    'oneOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == 1,
                    'moreOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] < -2,
                    } "
                  >
                    <span
                      class="twoUnder"
                      v-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == -2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == -1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == 1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == 2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                </template>
                <!-- out Team -->
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <template v-if="(playerData['team_hole_scores_R' + roundsPlayer]).split(',').slice(8,9) != ''">
                    <span
                      v-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(0, 9)
                        ) > data.course_out_par
                      "
                      class="down"
                    >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                    </span>
                    <span
                      v-else-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(0, 9)
                        ) < data.course_out_par
                      "
                      class="up"
                    >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                    </span>
                    <span v-else>
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                  </template>
                </td>
                <!-- end of out Team -->
                <td
                  class="CS"
                  v-for="(r1, index) in (
                    playerData['team_hole_vspars_R' + data.pft_round] || ''
                  )
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                  :class="{'twoUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -2, 
                  'oneUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -1,
                  'twoOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] > 1,
                  'oneOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == 1,
                  'moreOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9,18)[index] < -2,
                  } "
                >
                  <span
                    class="twoUnder"
                    v-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == -2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == -1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == 1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == 2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <!-- In Team -->
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <template v-if="(playerData['team_hole_scores_R' + roundsPlayer]).split(',').slice(17,18) != ''">
                    <span
                      v-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(9, 18)
                        ) > data.course_in_par
                      "
                      class="down"
                    >
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span
                      v-else-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(9, 18)
                        ) < data.course_in_par
                      "
                      class="up"
                    >
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span v-else>
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                  </template>
                </td>
                <!-- end of In Team -->
                <!-- Out Team -->
                <td
                  v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                  class="CS"
                >
                  <template v-if="playerData.holes === '18' || playerData.holes === F">
                    <span
                      v-if="
                        playerData['team_hole_vspars_R' + data.pft_round] >
                          data.course_total_par
                      "
                      class="down"
                    >
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                    <span
                      v-else-if="
                        playerData['team_hole_vspars_R' + data.pft_round] <
                          data.course_total_par
                      "
                      class="up"
                    >
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                    <span v-else>
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                  </template>
                </td>
                <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                  <template v-if="playerData.holes === '18' || playerData.holes === F">
                    <span
                      v-if="playerData.score > data.course_total_par"
                      class="down"
                    >
                      {{ playerData.score }}
                    </span>
                    <span
                      v-else-if="playerData.score < data.course_total_par"
                      class="up"
                    >
                      {{ playerData.score }}
                    </span>
                    <span v-else>
                      {{ playerData.score }}
                    </span>
                  </template>
                </td>
                <!-- End of Out Team -->
              </template>
              <!-- Old way -->
              <!-- (data.scores_type === 'N' && data.bball_team === 'Y') || data.strokeplay_team_event == 'Y' && data.team_net == 'Y'" -->
              <template
                v-else-if="
                  (data.scores_type === 'N' && data.bball_team === 'Y') || data.strokeplay_team_event == 'Y' && data.team_net == 'Y'"
              >
                <template v-if="playerData.pos !== 'CUT'">
                  <td
                    class="CS"
                    v-for="(r1, index) in (
                      playerData['team_hole_scores_R' + data.pft_round] || ''
                    )
                      .split(',')
                      .slice(0, 9)"
                    :key="index + Math.random()"
                    :class="{'twoUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -2, 
                    'oneUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -1,
                    'twoOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] > 1,
                    'oneOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == 1,
                    'moreOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] < -2,
                    } "
                  >
                    <span
                      class="twoUnder"
                      v-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == -2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == -1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == 1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="
                        (
                          playerData['team_hole_vspars_R' + data.pft_round] ||
                          ''
                        ).split(',')[index] == 2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                </template>
                <!-- out Team -->
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <template v-if="(playerData['team_hole_scores_R' + roundsPlayer]).split(',').slice(8,9) != ''">
                    <span
                      v-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(0, 9)
                        ) > data.course_out_par
                      "
                      class="down"
                    >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                    </span>
                    <span
                      v-else-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(0, 9)
                        ) < data.course_out_par
                      "
                      class="up"
                    >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                    </span>
                    <span v-else>
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                  </template>
                </td>
                <!-- end of out Team -->
                <td
                  class="CS"
                  v-for="(r1, index) in (
                    playerData['team_hole_scores_R' + data.pft_round] || ''
                  )
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                  :class="{'twoUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -2, 
                  'oneUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -1,
                  'twoOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] > 1,
                  'oneOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == 1,
                  'moreOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9,18)[index] < -2,
                  } "
                >
                  <span
                    class="twoUnder"
                    v-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == -2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == -1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == 1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="
                      (playerData['team_hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == 2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <!-- In Team -->
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <template v-if="(playerData['team_hole_scores_R' + roundsPlayer]).split(',').slice(17,18) != ''">
                    <span
                      v-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(9, 18)
                        ) > data.course_in_par
                      "
                      class="down"
                    >
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span
                      v-else-if="
                        sum(
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] ||
                            ''
                          )
                            .split(',')
                            .slice(9, 18)
                        ) < data.course_in_par
                      "
                      class="up"
                    >
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span v-else>
                      <span>
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData[
                                  "team_hole_vspars_R" + data.pft_round
                                ] || ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                  </template>
                </td>
                <!-- end of In Team -->
                <!-- Out Team -->
                <td
                  v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                  class="CS"
                >
                  <template v-if="playerData.holes === '18' || playerData.holes === F">
                    <span
                      v-if="
                        playerData['team_hole_vspars_R' + data.pft_round] >
                          data.course_total_par
                      "
                      class="down"
                    >
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                    <span
                      v-else-if="
                        playerData['team_hole_vspars_R' + data.pft_round] <
                          data.course_total_par
                      "
                      class="up"
                    >
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                    <span v-else>
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                  </template>
                </td>
                <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                  <template v-if="playerData.holes === '18' || playerData.holes === F">
                    <span
                      v-if="playerData.score > data.course_total_par"
                      class="down"
                    >
                      {{ playerData.score }}
                    </span>
                    <span
                      v-else-if="playerData.score < data.course_total_par"
                      class="up"
                    >
                      {{ playerData.score }}
                    </span>
                    <span v-else>
                      {{ playerData.score }}
                    </span>
                  </template>
                </td>
                <!-- End of Out Team -->
              </template>
              <template
                v-else-if="data.scores_type === 'G' && data.bball_team === 'Y'"
              >
                  <template v-if="playerData.pos !== 'CUT'">
                    <td
                      class="CS"
                      v-for="(r1, index) in (
                        playerData['team_hole_scores_R' + data.pft_round] || ''
                      )
                        .split(',')
                        .slice(0, 9)"
                      :key="index + Math.random()"
                      :class="{'twoUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -2, 
                      'oneUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == -1,
                      'twoOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] > 1,
                      'oneOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] == 1,
                      'moreOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',')[index] < -2,
                      } 
                    "
                    >
                      <span
                        class="twoUnder"
                        v-if="
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == -2
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span
                        class="oneUnder"
                        v-else-if="
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == -1
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span
                        class="oneOver"
                        v-else-if="
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == 1
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span
                        class="twoOver"
                        v-else-if="
                          (
                            playerData['team_hole_vspars_R' + data.pft_round] || ''
                          ).split(',')[index] == 2
                        "
                      >
                        {{ r1 }}
                      </span>
                      <span v-else>
                        {{ r1 }}
                      </span>
                    </td>
                  </template>
                  <td class="CS" v-if="playerData.pos !== 'CUT'">
                    <span
                      v-if="
                        sum(
                          (playerData['team_hole_scores_R' + data.pft_round] || '')
                            .split(',')
                            .slice(0, 9)
                        ) > data.course_out_par
                      "
                      class="down"
                    >
                      <span

                      >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData["team_hole_scores_R" + data.pft_round] ||
                                ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span
                      v-else-if="
                        sum(
                          (playerData['team_hole_scores_R' + data.pft_round] || '')
                            .split(',')
                            .slice(0, 9)
                        ) < data.course_out_par
                      "
                      class="up"
                    >
                      <span
                      >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData["team_hole_scores_R" + data.pft_round] ||
                                ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span v-else>
                      <span
                      >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData["team_hole_scores_R" + data.pft_round] ||
                                ""
                              )
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                  </td>
                  <td
                    class="CS"
                    v-for="(r1, index) in (
                      playerData['team_hole_scores_R' + data.pft_round] || ''
                    )
                      .split(',')
                      .slice(9, 18)"
                    :key="index + Math.random()"
                    :class="{'twoUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -2, 
                    'oneUnder': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == -1,
                    'twoOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] > 1,
                    'oneOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9, 18)[index] == 1,
                    'moreOver': (playerData['team_hole_vspars_R' + roundsPlayer] || '').split(',').slice(9,18)[index] < -2,
                    } 
                    "
                  >
                    <span
                      class="twoUnder"
                      v-if="
                        (playerData['team_hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == -2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="
                        (playerData['team_hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == -1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="
                        (playerData['team_hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == 1
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="
                        (playerData['team_hole_vspars_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)[index] == 2
                      "
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td class="CS" v-if="playerData.pos !== 'CUT'">
                    <span
                      v-if="
                        sum(
                          (playerData['team_hole_scores_R' + data.pft_round] || '')
                            .split(',')
                            .slice(9, 18)
                        ) > data.course_in_par
                      "
                      class="down"
                    >
                      <span
                      >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData["team_hole_scores_R" + data.pft_round] ||
                                ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span
                      v-else-if="
                        sum(
                          (playerData['team_hole_scores_R' + data.pft_round] || '')
                            .split(',')
                            .slice(9, 18)
                        ) < data.course_in_par
                      "
                      class="up"
                    >
                      <span
                      >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData["team_hole_scores_R" + data.pft_round] ||
                                ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                    <span v-else>
                      <span
                      >
                        <template
                          v-if="
                            playerData['score_R' + roundsPlayer] == 'WDN' ||
                              playerData['score_R' + roundsPlayer] == 'RTD' ||
                              playerData['score_R' + roundsPlayer] == 'DSQ'
                          "
                        >
                        </template>
                        <template v-else>
                          {{
                            sum(
                              (
                                playerData["team_hole_scores_R" + data.pft_round] ||
                                ""
                              )
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </template>
                      </span>
                    </span>
                  </td>

                  <td
                    v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                    class="CS"
                  >
                    <span
                      v-if="
                        playerData['team_hole_scores_R' + data.pft_round] >
                          data.course_total_par
                      "
                      class="down"
                    >
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                    <span
                      v-else-if="
                        playerData['team_hole_scores_R' + data.pft_round] <
                          data.course_total_par
                      "
                      class="up"
                    >
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                    <span v-else>
                      {{ playerData["score_R" + data.pft_round] }}
                    </span>
                  </td>
                  <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                    <span
                      v-if="playerData.score > data.course_total_par"
                      class="down"
                    >
                      {{ playerData.score }}
                    </span>
                    <span
                      v-else-if="playerData.score < data.course_total_par"
                      class="up"
                    >
                      {{ playerData.score }}
                    </span>
                    <span v-else>
                      {{ playerData.score }}
                    </span>
                  </td>
              </template>
              <template v-if="data.team_sb == 'Y'">
              <template
                v-if="
                  title.includes('Team') ||
                  data.score_type === 'P' ||
                    (data.tt_type === 'P' && data.stableford === 'Y')
                "
              >
                <td
                  class="CS"
                  v-for="(r1, index) in (
                    playerData['hole_points_R' + data.pft_round] || ''
                  )
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="
                      (
                        playerData['hole_vspars_R' + data.pft_round] || ''
                      ).split(',')[index] == -2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="
                      (
                        playerData['hole_vspars_R' + data.pft_round] || ''
                      ).split(',')[index] == -1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="
                      (
                        playerData['hole_vspars_R' + data.pft_round] || ''
                      ).split(',')[index] == 1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="
                      (
                        playerData['hole_vspars_R' + data.pft_round] || ''
                      ).split(',')[index] == 2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <span
                    v-if="
                      sum(
                        (playerData['hole_points_R' + data.pft_round] || '')
                          .split(',')
                          .slice(0, 9)
                      ) > data.course_out_par
                    "
                    class="down"
                  >
                    <template
                      v-if="
                        playerData['score_R' + roundsPlayer] == 'WDN' ||
                          playerData['score_R' + roundsPlayer] == 'RTD' ||
                          playerData['score_R' + roundsPlayer] == 'DSQ'
                      "
                    >
                    </template>
                    <template v-else>
                      {{
                        sum(
                          (playerData["hole_points_R" + data.pft_round] || "")
                            .split(",")
                            .slice(0, 9)
                        )
                      }}
                    </template>
                  </span>
                  <span
                    v-else-if="
                      sum(
                        (playerData['hole_points_R' + data.pft_round] || '')
                          .split(',')
                          .slice(0, 9)
                      ) < data.course_out_par
                    "
                    class="up"
                  >
                    <template
                      v-if="
                        playerData['score_R' + roundsPlayer] == 'WDN' ||
                          playerData['score_R' + roundsPlayer] == 'RTD' ||
                          playerData['score_R' + roundsPlayer] == 'DSQ'
                      "
                    >
                    </template>
                    <template v-else>
                      {{
                        sum(
                          (playerData["hole_points_R" + data.pft_round] || "")
                            .split(",")
                            .slice(0, 9)
                        )
                      }}
                    </template>
                  </span>
                  <span v-else>
                    <template
                      v-if="
                        playerData['score_R' + roundsPlayer] == 'WDN' ||
                          playerData['score_R' + roundsPlayer] == 'RTD' ||
                          playerData['score_R' + roundsPlayer] == 'DSQ'
                      "
                    >
                    </template>
                    <template v-else>
                      {{
                        sum(
                          (playerData["hole_points_R" + data.pft_round] || "")
                            .split(",")
                            .slice(0, 9)
                        )
                      }}
                    </template>
                  </span>
                </td>
                <td
                  class="CS"
                  v-for="(r1, index) in (
                    playerData['hole_points_R' + data.pft_round] || ''
                  )
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="
                      (playerData['hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == -2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="
                      (playerData['hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == -1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="
                      (playerData['hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == 1
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="
                      (playerData['hole_vspars_R' + data.pft_round] || '')
                        .split(',')
                        .slice(9, 18)[index] == 2
                    "
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td class="CS" v-if="playerData.pos !== 'CUT'">
                  <span
                    v-if="
                      sum(
                        (playerData['hole_points_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)
                      ) > data.course_in_par
                    "
                    class="down"
                  >
                    {{
                      sum(
                        (playerData["hole_points_R" + data.pft_round] || "")
                          .split(",")
                          .slice(0, 9)
                      )
                    }}
                  </span>
                  <span
                    v-else-if="
                      sum(
                        (playerData['hole_points_R' + data.pft_round] || '')
                          .split(',')
                          .slice(9, 18)
                      ) < data.course_in_par
                    "
                    class="up"
                  >
                    {{
                      sum(
                        (playerData["hole_points_R" + data.pft_round] || "")
                          .split(",")
                          .slice(9, 18)
                      )
                    }}
                  </span>
                  <span v-else>
                    {{
                      sum(
                        (playerData["hole_points_R" + data.pft_round] || "")
                          .split(",")
                          .slice(9, 18)
                      )
                    }}
                  </span>
                </td>
                <td
                  v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                  class="CS"
                >
                  <span
                    v-if="
                      playerData['hole_points_R' + data.pft_round] >
                        data.course_total_par
                    "
                    class="down"
                  >
                    {{ playerData["score_R" + data.pft_round] }}
                  </span>
                  <span
                    v-else-if="
                      playerData['hole_points_R' + data.pft_round] <
                        data.course_total_par
                    "
                    class="up"
                  >
                    {{ playerData["score_R" + data.pft_round] }}
                  </span>
                  <span v-else>
                    {{ playerData["score_R" + data.pft_round] }}
                  </span>
                </td>
                <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                  <span
                    v-if="playerData.score > data.course_total_par"
                    class="down"
                  >
                    {{ playerData.score }}
                  </span>
                  <span
                    v-else-if="playerData.score < data.course_total_par"
                    class="up"
                  >
                    {{ playerData.score }}
                  </span>
                  <span v-else>
                    {{ playerData.score }}
                  </span>
                </td>
              </template>
              </template>
              <template v-else>
                <!-- <template v-if="selected == '1'"> -->
                <template v-if="data.tt_enter_points == 'N'">
                  <template v-if="data.show_points_gross == 'P'">
                    <template
                      v-if="
                        data.score_type === 'P' ||
                          (data.tt_type === 'P' && data.stableford === 'Y')
                      "
                    >
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_points_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(0, 9)
                            ) > data.course_out_par
                          "
                          class="down"
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(0, 9)
                            ) < data.course_out_par
                          "
                          class="up"
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                        <span v-else>
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                      </td>
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_points_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) > data.course_in_par
                          "
                          class="down"
                        >
                          {{
                            sum(
                              (playerData["hole_points_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) < data.course_in_par
                          "
                          class="up"
                        >
                          {{
                            sum(
                              (playerData["hole_points_R" + data.pft_round] || "")
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </span>
                        <span v-else>
                          {{
                            sum(
                              (playerData["hole_points_R" + data.pft_round] || "")
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </span>
                      </td>
                      <td
                        v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                        class="CS"
                      >
                        <span
                          v-if="
                            playerData['hole_points_R' + data.pft_round] >
                              data.course_total_par
                          "
                          class="down"
                        >
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span
                          v-else-if="
                            playerData['hole_points_R' + data.pft_round] <
                              data.course_total_par
                          "
                          class="up"
                        >
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span v-else>
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                      </td>
                      <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                        <span
                          v-if="playerData.score > data.course_total_par"
                          class="down"
                        >
                          {{ playerData.score }}
                        </span>
                        <span
                          v-else-if="playerData.score < data.course_total_par"
                          class="up"
                        >
                          {{ playerData.score }}
                        </span>
                        <span v-else>
                          {{ playerData.score }}
                        </span>
                      </td>
                    </template>
                  </template>
                  <template v-else-if="data.show_points_gross == 'G'">
                    <template
                      v-if="
                        data.score_type === 'P' ||
                          (data.tt_type === 'P' && data.stableford === 'Y')
                      "
                    >
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_scores_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_scores_R' + data.pft_round] || '')
                                .split(',')
                                .slice(0, 9)
                            ) > data.course_out_par
                          "
                          class="down"
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_scores_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_scores_R' + data.pft_round] || '')
                                .split(',')
                                .slice(0, 9)
                            ) < data.course_out_par
                          "
                          class="up"
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_scores_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                        <span v-else>
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                      </td>
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_scores_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_scores_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) > data.course_in_par
                          "
                          class="down"
                        >
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_scores_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) < data.course_in_par
                          "
                          class="up"
                        >
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </span>
                        <span v-else>
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </span>
                      </td>
                      <td
                        v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                        class="CS"
                      >
                        <span
                          v-if="
                            playerData['hole_scores_R' + data.pft_round] >
                              data.course_total_par
                          "
                          class="down"
                        >
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span
                          v-else-if="
                            playerData['hole_scores_R' + data.pft_round] <
                              data.course_total_par
                          "
                          class="up"
                        >
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span v-else>
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                      </td>
                      <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                        <span
                          v-if="playerData.score > data.course_total_par"
                          class="down"
                        >
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 18)
                            )
                          }}
                        </span>
                        <span
                          v-else-if="playerData.score < data.course_total_par"
                          class="up"
                        >
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 18)
                            )
                          }}
                        </span>
                        <span v-else>
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 18)
                            )
                          }}
                        </span>
                      </td>
                    </template>
                  </template>
                  <template v-else-if="data.show_points_gross == 'B'">
                    <template
                      v-if="
                        data.score_type === 'P' ||
                          (data.tt_type === 'P' && data.stableford === 'Y')
                      "
                    >
                      <!-- <td
                        class="CS"
                        v-for="(r1, index) in (playerData)" :key="index + Math.random()"
                      >
                      <span>
                        Points {{r1}}
                      </span>
                      <span>
                        Gross {{r1.gross}}
                      </span>
                    </td> -->
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_scores_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else-if="!data.show_points_gross || (data.show_points_gross == 'G' || data.show_points_gross == 'B')">
                          {{ r1 }}
                        </span>
                        <span v-if="(data.show_points_gross == 'P' || data.show_points_gross == 'B')">
                          <br>{{ playerData['hole_points_R' + data.pft_round].split(',').slice(0,9)[index] }}
                        </span>
                      </td>
                      <!-- out -->
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <template v-if="(playerData['hole_scores_R' + roundsPlayer]).split(',').slice(8,9) != ''">
                          <span
                            v-if="
                              sum(
                                (playerData['hole_scores_R' + data.pft_round] || '')
                                  .split(',')
                                  .slice(0, 9)
                              ) > data.course_out_par
                            "
                            class="down"
                          >
                            <template
                              v-if="
                                playerData['score_R' + roundsPlayer] == 'WDN' ||
                                  playerData['score_R' + roundsPlayer] == 'RTD' ||
                                  playerData['score_R' + roundsPlayer] == 'DSQ'
                              "
                            >
                            </template>
                            <template v-else>
                              {{
                                sum(
                                  (playerData["hole_scores_R" + data.pft_round] || "")
                                    .split(",")
                                    .slice(0, 9)
                                )
                              }}
                            </template>
                          </span>
                          <span
                            v-else-if="
                              sum(
                                (playerData['hole_scores_R' + data.pft_round] || '')
                                  .split(',')
                                  .slice(0, 9)
                              ) < data.course_out_par
                            "
                            class="up"
                          >
                            <template
                              v-if="
                                playerData['score_R' + roundsPlayer] == 'WDN' ||
                                  playerData['score_R' + roundsPlayer] == 'RTD' ||
                                  playerData['score_R' + roundsPlayer] == 'DSQ'
                              "
                            >
                            </template>
                            <template v-else>
                              {{
                                sum(
                                  (playerData["hole_scores_R" + data.pft_round] || "")
                                    .split(",")
                                    .slice(0, 9)
                                )
                              }}
                            </template>
                          </span>
                          <span v-else-if="!data.show_points_gross || (data.show_points_gross == 'G' || data.show_points_gross == 'B')">
                            <template
                              v-if="
                                playerData['score_R' + roundsPlayer] == 'WDN' ||
                                  playerData['score_R' + roundsPlayer] == 'RTD' ||
                                  playerData['score_R' + roundsPlayer] == 'DSQ'
                              "
                            >
                            </template>
                            <template v-else>
                              {{
                                sum(
                                  (playerData["hole_scores_R" + data.pft_round] || "")
                                    .split(",")
                                    .slice(0, 9)
                                )
                              }}
                            </template>
                          </span>

                          <span v-if="(data.show_points_gross == 'P' || data.show_points_gross == 'B')">
                            <br>
                            {{ sum((
                                  playerData['hole_points_R' + data.pft_round] || "").split(',').slice(0,9) )}}
                          </span>
                        </template>

                      </td>
                      <!-- 9-18 -->
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_scores_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else-if="!data.show_points_gross || (data.show_points_gross == 'G' || data.show_points_gross == 'B')">
                          {{ r1 }}
                        </span>
                        <span v-if="(data.show_points_gross == 'P' || data.show_points_gross == 'B')">
                          <br>{{ playerData['hole_points_R' + data.pft_round].split(',').slice(9,18)[index] }}
                        </span>
                      </td>
                      <!-- in -->
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <template v-if="(playerData['hole_scores_R' + roundsPlayer]).split(',').slice(17,18) != ''">
                          <span
                            v-if="
                              sum(
                                (playerData['hole_scores_R' + data.pft_round] || '')
                                  .split(',')
                                  .slice(9, 18)
                              ) > data.course_in_par
                            "
                            class="down"
                          >
                            {{
                              sum(
                                (playerData["hole_scores_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </span>
                          <span
                            v-else-if="
                              sum(
                                (playerData['hole_scores_R' + data.pft_round] || '')
                                  .split(',')
                                  .slice(9, 18)
                              ) < data.course_in_par
                            "
                            class="up"
                          >
                            {{
                              sum(
                                (playerData["hole_scores_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(9, 18)
                              )
                            }}
                          </span>
                          <span v-else-if="!data.show_points_gross || (data.show_points_gross == 'G' || data.show_points_gross == 'B')">
                            {{
                              sum(
                                (playerData["hole_scores_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(9, 18)
                              )
                            }}
                          </span>
                          <span v-if="(data.show_points_gross == 'P' || data.show_points_gross == 'B')">
                            <br>
                            {{ sum((
                                  playerData['hole_points_R' + data.pft_round] || "").split(',').slice(9,18) )
                            }} 
                            <!-- 0 -->
                          </span>
                        </template>
                      </td>
                      <!-- out -->
                      <td
                        v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                        class="CS"
                      >
                      <template v-if="playerData.holes === '18' || playerData.holes === F">
                        <span
                          v-if="
                            playerData['hole_scores_R' + data.pft_round] >
                              data.course_total_par
                          "
                          class="down"
                        >
                          {{ sum((
                                  playerData['hole_scores_R' + data.pft_round] || "").split(',').slice(0,18) )}}
                        </span>
                        <span
                          v-else-if="
                            playerData['hole_scores_R' + data.pft_round] <
                              data.course_total_par
                          "
                          class="up"
                        >
                           {{ sum((
                                  playerData['hole_scores_R' + data.pft_round] || "").split(',').slice(0,18) )}}
                        </span>
                        <span v-else-if="!data.show_points_gross || (data.show_points_gross == 'G' || data.show_points_gross == 'B')">
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span v-if="(data.show_points_gross == 'P' || data.show_points_gross == 'B')">
                          <br>
                          {{ sum((
                                  playerData['hole_points_R' + data.pft_round] || "").split(',').slice(0,18) )}}
                        </span>
                      </template>
                      </td>
                      <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                        <span
                          v-if="playerData.score > data.course_total_par"
                          class="down"
                        >
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 18)
                            )
                          }}
                        </span>
                        <span
                          v-else-if="playerData.score < data.course_total_par"
                          class="up"
                        >
                          {{
                            sum(
                              (playerData["hole_scores_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 18)
                            )
                          }}
                        </span>
                        <span v-else-if="!data.show_points_gross || (data.show_points_gross == 'G' || data.show_points_gross == 'B')">
                          {{ playerData.score }}
                        </span>
                        <span v-if="(data.show_points_gross == 'P' || data.show_points_gross == 'B')">
                          <br>
                          {{ playerData.score }}
                        </span>
                      </td>
                    </template>
                  </template>
                </template>
                <template v-else>
                  <template>
                    <template
                      v-if="
                        data.score_type === 'P' ||
                          (data.tt_type === 'P' && data.stableford === 'Y')
                      "
                    >
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_points_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (
                              playerData['hole_vspars_R' + data.pft_round] || ''
                            ).split(',')[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(0, 9)
                            ) > data.course_out_par
                          "
                          class="down"
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(0, 9)
                            ) < data.course_out_par
                          "
                          class="up"
                        >
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                        <span v-else>
                          <template
                            v-if="
                              playerData['score_R' + roundsPlayer] == 'WDN' ||
                                playerData['score_R' + roundsPlayer] == 'RTD' ||
                                playerData['score_R' + roundsPlayer] == 'DSQ'
                            "
                          >
                          </template>
                          <template v-else>
                            {{
                              sum(
                                (playerData["hole_points_R" + data.pft_round] || "")
                                  .split(",")
                                  .slice(0, 9)
                              )
                            }}
                          </template>
                        </span>
                      </td>
                      <td
                        class="CS"
                        v-for="(r1, index) in (
                          playerData['hole_points_R' + data.pft_round] || ''
                        )
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == -1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 1
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="
                            (playerData['hole_vspars_R' + data.pft_round] || '')
                              .split(',')
                              .slice(9, 18)[index] == 2
                          "
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td class="CS" v-if="playerData.pos !== 'CUT'">
                        <span
                          v-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) > data.course_in_par
                          "
                          class="down"
                        >
                          {{
                            sum(
                              (playerData["hole_points_R" + data.pft_round] || "")
                                .split(",")
                                .slice(0, 9)
                            )
                          }}
                        </span>
                        <span
                          v-else-if="
                            sum(
                              (playerData['hole_points_R' + data.pft_round] || '')
                                .split(',')
                                .slice(9, 18)
                            ) < data.course_in_par
                          "
                          class="up"
                        >
                          {{
                            sum(
                              (playerData["hole_points_R" + data.pft_round] || "")
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </span>
                        <span v-else>
                          {{
                            sum(
                              (playerData["hole_points_R" + data.pft_round] || "")
                                .split(",")
                                .slice(9, 18)
                            )
                          }}
                        </span>
                      </td>
                      <td
                        v-if="data.rounds_played > 1 && playerData.pos !== 'CUT'"
                        class="CS"
                      >
                        <span
                          v-if="
                            playerData['hole_points_R' + data.pft_round] >
                              data.course_total_par
                          "
                          class="down"
                        >
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span
                          v-else-if="
                            playerData['hole_points_R' + data.pft_round] <
                              data.course_total_par
                          "
                          class="up"
                        >
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                        <span v-else>
                          {{ playerData["score_R" + data.pft_round] }}
                        </span>
                      </td>
                      <td v-else-if="playerData.pos !== 'CUT'" class="CS">
                        <span
                          v-if="playerData.score > data.course_total_par"
                          class="down"
                        >
                          {{ playerData.score }}
                        </span>
                        <span
                          v-else-if="playerData.score < data.course_total_par"
                          class="up"
                        >
                          {{ playerData.score }}
                        </span>
                        <span v-else>
                          {{ playerData.score }}
                        </span>
                      </td>
                    </template>
                  </template>
                </template>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Information from "@ocs-software/vue-ocs/ocs/reports/information.vue";
export default {
  name: "hbh",
  props: ["data", "config", "title", "showGender", "develop", "show_info_web", "hide_score_card"],
  components: {
    Information
  },
  data() {
    return {
      up: "up",
      down: "down",
      CS: "CS",
      CV: "CV",
      CT: "CT",
      CN: "CN",
      CP: "CP",
      CF: "CF",
      playerData: [],
    };
  },
  computed: {
    roundsPlayer: function() {
      return parseInt(this.data.pft_round);
    }
  },
  watch: {
    scores: {
      immediate: true,
      handler(newValue, oldValue) {
        if (!newValue || !oldValue) { return }
        newValue.forEach((value1, key1) => {
          oldValue.forEach((value2, key2) => {
            if (value1.id === value2.id) {
              if (key1 < key2) {
                value1.posChang = "up";
              } else if (key1 > key2) {
                value1.posChang = "down";
              }
            }
          });
        });

        console.log(newValue);
      },
      deep: true
    }
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  },
  methods: {
    grossB: function() {
      let playerData = [
        {
          points: [],
          gross: []
        }
      ];
      this.playerData = playerData;
      console.log("this.arrPoints" )
      console.log(this.playerData) 
      this.data.scores.scores_entry.forEach((value) => {
          playerData[0]['points'].push(value['hole_points_R' + this.data.pft_round].split(','));
          playerData[0]['gross'].push(value['hole_scores_R' + this.data.pft_round].split(','));
      });
    },

    sum: function(nums) {
      let result = 0;
      nums.forEach(function(n) {
        result += n * 1;
      });
      if (result == 0) {
        result = ''
      } else {
        return result; 
      }
    },
    course_par: function(start, end) {
      if(!this.data.course_par) { return }
      return this.data.course_par.split(',').slice(start, end)
    }
  },
  created() {
    this.grossB();
  }
};
</script>
